import { Component } from 'react';
import { withTranslation } from 'react-i18next';

import DataTable from '../../../../components/Datatable';
import { getSortKeys, setAdditionalStyles } from '../../../../helpers/table';
import { reportsPosition } from '../../GscTools/metrics';
import { COVERAGE } from '../hours';
import { evidenceColumns } from '../keys';
import { evidenceRows } from '../rows';

/**
 * Block 03 — every hour that came back, exactly as it came back.
 *
 * It is the same response the chart above is drawn from, read as rows. Expanding it costs no
 * request: the hourly response is twenty-four rows, it is already here, and asking Search Console
 * again for what it just sent would spend a reader's request budget on nothing.
 *
 * Unlike the chart, this table never hides the provisional hours — not in either coverage mode.
 * They are marked, and they are the rows a reader checking a sudden drop came here for. Hiding
 * the hours in question from the evidence table would leave the question unanswerable.
 *
 * Sorting reorders this table alone. The chart stays chronological, because an hourly series read
 * in any other order is not a series.
 */
class HourEvidence extends Component {
    constructor(props) {
        super(props);
        this.searchFunction = this.searchFunction.bind(this);
    }

    searchFunction(nodes, search) {
        if (!search) return nodes;
        const term = search.toLowerCase();
        return nodes.filter((row) => row.key?.toLowerCase().includes(term));
    }

    render() {
        const { t, scope, hours } = this.props;

        const hasPosition = reportsPosition(scope.searchType);
        const rows = evidenceRows(hours, hasPosition);
        const columns = evidenceColumns(t, { hasPosition });
        const provisional = rows.filter((row) => row.provisional).length;

        return (
            <div className="card table-main rounded-main overflow-hidden gsc-tool-block">
                <div className="card-header d-flex justify-content-between">
                    <div>
                        <p className="card-title">{t('tools.latest_hours.evidence.title')}</p>
                        <p className="gsc-tool-sub">
                            {t('tools.latest_hours.evidence.description')}
                        </p>
                        <p className="gsc-tool-rows-hint">
                            <i className="icon-info" aria-hidden="true" />
                            {t('tools.latest_hours.evidence.sort_hint')}
                        </p>
                    </div>
                </div>

                <div className="card-body">
                    <DataTable
                        nodes={rows}
                        COLUMNS={columns}
                        sortFns={getSortKeys(columns)}
                        additionalStyles={setAdditionalStyles(columns)}
                        searchFunction={this.searchFunction}
                        fileName={t('tools.latest_hours.evidence.file')}
                        customEmptyMessage={t('tools.latest_hours.evidence.empty')}
                        customContainerStyles="gsc-tool-key-table"
                    />

                    <p className="gsc-tool-table-note">
                        {t('tools.latest_hours.evidence.returned', {
                            rows: rows.length,
                            provisional,
                        })}
                    </p>
                    <p className="gsc-tool-table-note">
                        {scope.coverage === COVERAGE.ALL
                            ? t('tools.latest_hours.evidence.all_note')
                            : t('tools.latest_hours.evidence.comparable_note')}
                    </p>
                    <p className="gsc-tool-table-note">
                        {t('tools.latest_hours.evidence.position_note')}
                    </p>
                </div>
            </div>
        );
    }
}

export default withTranslation()(HourEvidence);
